import React, { useEffect, useState } from 'react';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Drawer from '@mui/material/Drawer';
import { LeftSideNav } from '@im/ui-lib/LeftSideNav';
import { LeftSideNavMobile } from '@im/ui-lib/LeftSideNavMobile';
import { NavItem, useNavTo } from '@im/ui-lib/nav';
import { useSideNavItems } from '../../app/nav/side-nav-items';
import { useLocation } from 'react-router-dom';
import { useHelpNavItems } from '../../app/nav/useHelpNavItems';
import { handleInternalSearch } from '../../utils/trackProductsInternalSearch';

type Props = {
  drawerOpen: boolean;
  headerHeight: number;
  hoverRequired: boolean;
  isAuthenticated: boolean;
  isCheckout: boolean;
  isMobile: boolean;
  isTempDrawer: boolean;
  setDrawerOpen: (action: boolean) => void;
};

export function IngramSideNav(props: Props) {
  const {
    drawerOpen,
    headerHeight,
    isAuthenticated,
    isCheckout,
    isMobile,
    isTempDrawer,
    setDrawerOpen,
  } = props;
  const { pathname, search } = useLocation();
  const [activeSideNavItem, setActiveSideNavItem] = useState<
    NavItem | undefined
  >();
  const [enableApi, setEnableApi] = useState(false);
  const enableMenuApi = enableApi || isAuthenticated || isMobile;
  const sideNavItems = useSideNavItems(enableMenuApi);
  const navTo = useNavTo();
  const onNavItemClick = (navItem: NavItem) => {
    setDrawerOpen(false);
    handleInternalSearch(navItem, pathname, navTo);
  };
  const helpNavItems = useHelpNavItems();

  useEffect(() => {
    if (pathname === '/home' || pathname === '/my/dashboard') {
      setActiveSideNavItem(sideNavItems[0]);
    }

    if (isAuthenticated) {
      if (
        pathname === '/frame' ||
        pathname === '/product/favoriteproducts' ||
        pathname === '/my/bid/bidlist' ||
        pathname === '/my/quotemgmt/quotelist'
      ) {
        setActiveSideNavItem(sideNavItems[1]);
      } else if (
        pathname === '/product/productsearch' &&
        !search.includes('vendor')
      ) {
        setActiveSideNavItem(sideNavItems[2]);
      } else if (
        pathname === '/product/productsearch' &&
        search.includes('vendor')
      ) {
        setActiveSideNavItem(sideNavItems[3]);
      } else if (pathname.includes('cms')) {
        if (pathname.includes('solutions')) {
          setActiveSideNavItem(sideNavItems[4]);
        } else if (pathname.includes('services')) {
          setActiveSideNavItem(sideNavItems[5]);
        } else if (pathname.includes('resources')) {
          setActiveSideNavItem(sideNavItems[6]);
        } else if (pathname.includes('Events')) {
          setActiveSideNavItem(sideNavItems[7]);
        }
      }
    } else if (
      pathname === '/product/productsearch' &&
      search.includes('vendor')
    ) {
      setActiveSideNavItem(sideNavItems[1]);
    } else if (pathname.includes('cms')) {
      if (pathname.includes('solutions')) {
        setActiveSideNavItem(sideNavItems[2]);
      } else if (pathname.includes('services')) {
        setActiveSideNavItem(sideNavItems[3]);
      } else if (pathname.includes('resources')) {
        setActiveSideNavItem(sideNavItems[4]);
      } else if (pathname.includes('Events')) {
        setActiveSideNavItem(sideNavItems[5]);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname, search, isAuthenticated]);

  return (
    <ClickAwayListener
      mouseEvent="onMouseDown"
      onClickAway={() => drawerOpen && setDrawerOpen(false)}
      touchEvent="onTouchStart"
    >
      {isMobile && !isAuthenticated ? (
        <Drawer
          aria-label="app navigation"
          onClose={() => setDrawerOpen(false)}
          open={drawerOpen}
          sx={{
            '& .MuiBackdrop-root': {
              position: 'unset',
            },
            '& .MuiDrawer-paper': {
              borderRight: `1px solid #D1D1D1`,
              boxShadow: 'none',
              height: '100%',
            },
            position: 'relative',
          }}
          variant={'temporary'}
        >
          <LeftSideNavMobile
            activeSideNavItem={activeSideNavItem}
            helpNavItems={helpNavItems}
            hoverRequired={true}
            isHelpNavItemVisible={true}
            navItems={sideNavItems}
            onClose={() => setDrawerOpen(false)}
            onNavItemClick={onNavItemClick}
            setActiveSideNavItem={setActiveSideNavItem}
          />
        </Drawer>
      ) : (
        <Drawer
          aria-label="app navigation"
          onClose={() => setDrawerOpen(false)}
          onFocus={
            !enableMenuApi
              ? () => {
                  setEnableApi(true);
                }
              : undefined
          }
          onMouseEnter={
            !enableMenuApi
              ? () => {
                  setEnableApi(true);
                }
              : undefined
          }
          open={isTempDrawer ? drawerOpen : true}
          sx={{
            '& .MuiBackdrop-root': {
              position: 'unset',
            },
            '& .MuiDrawer-paper': {
              borderRight: `1px solid #D1D1D1`,
              boxShadow: 'none',
              height: '100%',
              top: headerHeight,
            },
            position: 'relative',
          }}
          variant={isTempDrawer ? 'temporary' : 'persistent'}
        >
          {!isCheckout ? (
            <LeftSideNav
              activeSideNavItem={activeSideNavItem}
              headerHeight={headerHeight}
              hoverRequired={true}
              isAuthenticated={isAuthenticated}
              isHelpNavItemVisible={false}
              navItems={sideNavItems}
              onNavItemClick={onNavItemClick}
              setActiveSideNavItem={setActiveSideNavItem}
            />
          ) : (
            <LeftSideNav
              activeSideNavItem={undefined}
              headerHeight={headerHeight}
              hoverRequired={false}
              isAuthenticated={isAuthenticated}
              isHelpNavItemVisible={false}
              navItems={[]}
              onNavItemClick={() => {
                return 0;
              }}
              setActiveSideNavItem={setActiveSideNavItem}
            />
          )}
        </Drawer>
      )}
    </ClickAwayListener>
  );
}
